<div class="flex flex-row pt-0 mb-4 mr-5 ml-0 gap-5 cursor-pointer">
    <p class="font-semibold text-[#424242] dark:text-white">Officer Targets</p>
    <!-- <p class="font-semibold text-sm text-[#424242] dark:text-white" onclick="history.back()">Center Dashboard</p> -->
</div>


<app-loading-spinner *ngIf="isLoading" />


<div class="w-full px-10 py-7 bg-tileLight shadow-lg rounded-lg dark:bg-[#363636]">

    <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4 mt-5">


        <div>
            <label class="block text-sm font-semibold text-[#534E4E] dark:text-textDark">EMP ID / User name</label>
            <div class="flex mt-1">
                <span
                    class="inline-flex items-center px-3 py-2 text-gray-900 bg-gray-200 border border-e-0 border-gray-300 rounded-s-md dark:bg-[#1D1D1F] dark:text-gray-400 ">

                    <p *ngIf="OfficerObj.jobRole === 'Collection Officer'">COO</p>

                </span>
                <input type="text" name="officerId" [(ngModel)]="OfficerObj.officerId" placeholder="ex : 00122"
                    class="rounded-none rounded-e-lg bg-gray-50 border border-gray-300 text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm pl-4  dark:bg-[#1D1D1F]  dark:placeholder-gray-400 dark:text-textDark dark:focus:ring-blue-500 dark:focus:border-blue-500">
            </div>
        </div>
    </div>

    <!-- <hr class="border-b-1 border-[#BDBDBD] my-5" /> -->

    <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4 mt-5">



        <div class="w-full">
            <label for="fromDate" class="block text-sm font-semibold text-gray-700 dark:text-textDark">From</label>

            <div class="relative w-full">
                <app-custom-datepicker #fromDatePicker [placeholder]="'--Select Date--'"
                    [(selectedDate)]="OfficerObj.fromDate" (dateChange)="checkFromDate($event)">
                </app-custom-datepicker>
            </div>

        </div>

        <div class="w-full">
            <label for="toDate" class="block text-sm font-semibold text-gray-700 dark:text-textDark">To</label>

            <div class="relative w-full">
                <app-custom-datepicker #toDatePicker [placeholder]="'--Select Date--'"
                    [selectedDate]="OfficerObj.toDate" (dateChange)="checkToDate($event)">
                </app-custom-datepicker>
            </div>

        </div>

    </div>

    <div class="flex flex-row justify-center items-center gap-12 mt-10 ">
        <button class="bg-[#415CFF] text-white rounded-lg shadow-md px-6 py-2" (click)="onSubmit()">Genarate</button>
    </div>


    <div *ngIf="!hasData && !isInitialDataSet "
        class="flex flex-col items-center w-full min-h-screen px-10 py-7 bg-tileLight dark:bg-[#363636] rounded-lg mt-6">
        <p class="text-[#494949] my-6 dark:text-white">
            {{responseTitle}}
        </p>
        <img src="assets/images/NoData.png" alt="No Data" class="w-20 h-20" />
    </div>



    <div *ngIf='isInitialDataSet'
        class="w-full px-10 py-7 bg-tileLight dark:bg-[#363636] rounded-lg mt-8">

        <div *ngIf="!noPermission"
        class="">
            <p class="font-semibold mb-1 text-lg dark:text-white whitespace-nowrap">
                {{OfficerObj.fromDate + ' - ' + OfficerObj.toDate}} </p>
        </div>

        <div *ngIf="!noPermission" class="flex flex-row flex-wrap items-center justify-between gap-4 mb-8">
            <div class="flex flex-row gap-4 flex-shrink-0">

                <p class="font-semibold mb-1 text-lg dark:text-white whitespace-nowrap">EMP ID:
                    {{OfficerObj.empId}} </p>
            </div>
            <div class="flex flex-row flex-wrap items-center justify-end gap-5 flex-1 min-w-0">
                <!-- <i class="fa-solid fa-list text-2xl dark:text-white ml-8"></i>

            <p class="font-normal dark:text-white">Filter By</p> -->

                <div class="relative w-40 flex-shrink-0 custom-status-dropdown-container">
                    <select [(ngModel)]="selectStatus" class="hidden" (change)="applyStatusFilters()">
                        <option class="dark:bg-[#292929] text-textLight dark:text-textDark hover:bg-gray-300"
                            value="Pending">Pending</option>
                        <option class="dark:bg-[#292929] text-textLight dark:text-textDark hover:bg-gray-300"
                            value="Completed">Completed</option>
                        <option class="dark:bg-[#292929] text-textLight dark:text-textDark hover:bg-gray-300"
                            value="Exceeded">Exceeded</option>
                        <option class="dark:bg-[#292929] text-textLight dark:text-textDark hover:bg-gray-300"
                            value="Extra">Extra</option>
                    </select>

                    <div class="border-[1.8px] border-[#828282] rounded-xl dark:bg-[#292929] text-textLight dark:text-textDark"
                        (click)="toggleStatusDropdown()">
                        <div class="flex flex-row justify-between items-center px-3 py-2 cursor-pointer">
                            <span>{{ selectStatus || 'Status' }}</span>
                            <div class="flex items-center">
                                <i *ngIf="selectStatus" (click)="clearStatusFilter($event)"
                                    class="fa-solid fa-xmark text-lg text-[#828282] mr-2 hover:text-[#555] dark:hover:text-[#aaa] cursor-pointer"></i>
                                <i *ngIf="isStatusDropdownOpen || !selectStatus"
                                    class="fa-solid text-lg text-[#828282] transition-transform duration-200"
                                    [class.fa-angle-down]="!isStatusDropdownOpen"
                                    [class.fa-angle-up]="isStatusDropdownOpen"></i>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="isStatusDropdownOpen"
                        class="absolute overflow-hidden z-10 w-full mt-1 bg-white dark:bg-[#292929] rounded-xl shadow-lg border border-[#828282]">
                        <div *ngFor="let option of statusDropdownOptions; let i = index"
                            (click)="selectStatusOption(option)"
                            class="px-3 py-2 hover:bg-gray-300 dark:text-textDark dark:hover:bg-gray-600 cursor-pointer flex items-center"
                            [ngClass]="{
                'rounded-t-xl': i === 0,
                'rounded-b-xl': i === statusDropdownOptions.length - 1
            }">
                            <span class="flex-grow">{{ option }}</span>
                        </div>
                    </div>
                </div>

                <!-- Validity Dropdown -->
                <div class="relative w-40 flex-shrink-0 custom-validity-dropdown-container">
                    <select [(ngModel)]="selectValidity" class="hidden">
                        <option class="dark:bg-[#292929] text-textLight dark:text-textDark hover:bg-gray-300"
                            value="Expired">Expired</option>
                        <option class="dark:bg-[#292929] text-textLight dark:text-textDark hover:bg-gray-300"
                            value="Active">Active</option>
                        <option class="dark:bg-[#292929] text-textLight dark:text-textDark hover:bg-gray-300"
                            value="Unassigned">Unassigned</option>
                    </select>

                    <div class="border-[1.8px] border-[#828282] rounded-xl dark:bg-[#292929] text-textLight dark:text-textDark"
                        (click)="toggleValidityDropdown()">
                        <div class="flex flex-row justify-between items-center px-3 py-2 cursor-pointer">
                            <span>{{ selectValidity || 'Validity' }}</span>
                            <div class="flex items-center">
                                <i *ngIf="selectValidity" (click)="clearValidityFilter($event)"
                                    class="fa-solid fa-xmark text-lg text-[#828282] mr-2 hover:text-[#555] dark:hover:text-[#aaa] cursor-pointer"></i>
                                <i *ngIf="isValidityDropdownOpen || !selectValidity"
                                    class="fa-solid text-lg text-[#828282] transition-transform duration-200"
                                    [class.fa-angle-down]="!isValidityDropdownOpen"
                                    [class.fa-angle-up]="isValidityDropdownOpen"></i>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="isValidityDropdownOpen"
                        class="absolute overflow-hidden z-10 w-full mt-1 bg-white dark:bg-[#292929] rounded-xl shadow-lg border border-[#828282]">
                        <div *ngFor="let option of validityDropdownOptions; let i = index"
                            (click)="selectValidityOption(option)"
                            class="px-3 py-2 hover:bg-gray-300 dark:text-textDark dark:hover:bg-gray-600 cursor-pointer flex items-center"
                            [ngClass]="{
                'rounded-t-xl': i === 0,
                'rounded-b-xl': i === validityDropdownOptions.length - 1
            }">
                            <span class="flex-grow">{{ option }}</span>
                        </div>
                    </div>
                </div>


                <div class="flex items-center rounded-full px-4 py-2 flex-1 min-w-48 max-w-xs bg-[#F1F1F1] dark:bg-[#292929]">
                    <input type="text" placeholder="Search by Variety Name" [(ngModel)]="searchText"
                        (input)="trimedSearchText()" (keyup.enter)="onSearch()" (keyup.esc)="offSearch()"
                        class="bg-transparent outline-none w-full min-w-0 text-textLight dark:text-textDark" />
                    <button type="button" class="text-gray-500 hover:text-gray-700 focus:outline-none mr-2"
                        (click)="onSearch()">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
                            stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M21 21l-6-6m2-5a7 7 0 10-14 0 7 7 0 0014 0z" />
                        </svg>
                    </button>
                    <button type="button" class="text-gray-500 hover:text-gray-700 focus:outline-none"
                        (click)="offSearch()">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
                            stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                </div>

            </div>

        </div>

        <div *ngIf="!hasData && isInitialDataSet" class="flex flex-col items-center w-full h-screen px-10 py-7 mt-6 ">
            <p class="text-[#494949] my-6 dark:text-textDark">{{responseTitle}}</p>
            <img src="assets/images/NoData.png" alt="No Data" class="w-20 h-20" />
        </div>


        <div *ngIf="hasData && isInitialDataSet">
          <div class="isolate overflow-auto max-h-[max(440px,calc(100vh-920px))] border-gray-100 border-[2px] rounded-lg dark:border-[#202021]">
            <table class="w-full min-w-max divide-y-2">
                <thead class="sticky top-0 z-20 bg-white text-gray-700 dark:text-gray-300 dark:bg-[#0F0F0F] dark:border-[#202021]">
                    <tr>
                        <th class="sticky left-0 bg-white dark:bg-[#0F0F0F] w-20 min-w-20 px-6 py-3 text-left font-medium">No</th>
                        <th class="sticky left-20 bg-white dark:bg-[#0F0F0F] w-44 min-w-44 px-6 py-3 text-left font-medium">Crop Name</th>
                        <th class="px-6 py-3 text-left font-medium">Variety Name</th>
                        <th class="px-6 py-3 text-left font-medium">Grade</th>
                        <th class="px-6 py-3 text-left font-medium">Target (kg)</th>
                        <th class="px-6 py-3 text-left font-medium">To Do (kg)</th>
                        <th class="px-6 py-3 text-left font-medium">Completed (kg)</th>
                        <th class="px-6 py-3 text-left font-medium">Date</th>
                        <th class="px-6 py-3 font-medium text-center">Status</th>
                        <th class="px-6 py-3 font-medium text-center">Validity</th>
                        <th class="px-6 py-3 text-left font-medium"></th>
                    </tr>
                </thead>
                <tbody class="bg-white dark:bg-[#1D1D1F] dark:border-[#1D1D1F]">
                    <tr
                        *ngFor="let item of targetArr | paginate : { itemsPerPage: itemsPerPage, currentPage: page, totalItems: totalItems }; let i = index">
                        <td class="sticky left-0 z-10 bg-white dark:bg-[#1D1D1F] px-6 py-4 text-gray-900 dark:text-gray-300">
                            {{ (((page - 1) * itemsPerPage) + i + 1) < 10 ? '0' + (((page - 1) * itemsPerPage) + i + 1)
                                : (((page - 1) * itemsPerPage) + i + 1) }} </td>
                        <td class="sticky left-20 z-10 bg-white dark:bg-[#1D1D1F] px-6 py-4 text-black dark:text-gray-300 break-words">{{item.cropNameEnglish}}</td>
                        <td class="px-6 py-4 text-black dark:text-gray-300 ">{{item.varietyNameEnglish}}</td>
                        <td class="px-6 py-4 text-black dark:text-gray-300 text-center">{{item.grade}}</td>
                        <td class="px-6 py-4 text-black dark:text-gray-300">
                            {{ item.target | number:'1.3-3' }}
                        </td>

                        <td class="px-6 py-4 text-black dark:text-gray-300">
                            {{ claculateTodo(item.target, item.complete) | number:'1.3-3' }}
                        </td>

                        <td class="px-6 py-4 text-black dark:text-gray-300">
                            {{ item.complete | number:'1.3-3' }}
                        </td>
                        <td class="px-6 py-4 text-black-900 dark:text-gray-300 ">{{item.date}}</td>
                        <td class="px-6 py-4 text-gray-[#000000] font-semibold dark:text-gray-300">
                            <div class="flex justify-center">
                                <span *ngIf="item.status === 'Pending'"
                                    class="bg-[#F8FFA6] text-[#A8A100] text-center rounded-lg w-28 py-1 flex items-center justify-center">
                                    Pending
                                </span>
                                <span *ngIf="item.status === 'Exceeded'"
                                    class="bg-[#C8E0FF] text-[#415CFF] text-center rounded-lg w-28 py-1 flex items-center justify-center">
                                    Exceeded
                                </span>
                                <span *ngIf="item.status === 'Completed'"
                                    class="bg-[#c0f8ac] text-[#30911a] text-center rounded-lg w-28 py-1 flex items-center justify-center">
                                    Completed
                                </span>
                                <span *ngIf="item.status === 'Extra'"
                                    class="bg-[#FFE4C9] text-[#CD6700] text-center rounded-lg w-28 py-1 flex items-center justify-center">
                                    Extra
                                </span>
                            </div>
                        </td>
                        <td class="px-6 py-4 text-gray-[#000000] font-semibold dark:text-gray-300">
                            <div class="flex justify-center">
                                <span *ngIf="item.validity === 'Unassigned'"
                                    class="bg-[#B7F4FF] text-[#008CA2] text-center rounded-lg w-28 py-1 flex items-center justify-center">
                                    Unassigned
                                </span>
                                <span *ngIf="item.validity === 'Expired'"
                                    class="bg-[#D9D9D9] text-[#8A8A8A] text-center rounded-lg w-28 py-1 flex items-center justify-center">
                                    Expired
                                </span>
                                <span *ngIf="item.validity === 'Active'"
                                    class="bg-[#c0f8ac] text-[#30911a] text-center rounded-lg w-28 py-1 flex items-center justify-center">
                                    Active
                                </span>
                            </div>
                        </td>
                        <td class="px-6 py-4">
                            <!-- <i class="fa-solid fa-pen-to-square text-xl cursor-pointer"
                            (click)="item.validity === 'Valid' && editOfficerTarget(item.id, OfficerObj.toDate, OfficerObj.fromDate)"
                            [ngClass]="{
                             'text-gray-400': item.validity === 'Expired' || (item.validity === 'Valid' && (item.target === item.complete || item.target < item.complete)),
                             'text-[#415CFF]': item.validity === 'Valid' && item.target > item.complete
                           }">
                        </i> -->
                            <button [disabled]="!(item.validity === 'Active' && item.status === 'Pending')"
                                (click)="editOfficerTarget(item.id, OfficerObj.toDate, OfficerObj.fromDate, OfficerObj.officerId, OfficerObj.empId )"
                                class="cursor-pointer">
                                <i class="fa-solid fa-pen-to-square text-xl" [ngClass]="{
      'text-[#415CFF] cursor-pointer': item.validity === 'Active' && item.status === 'Pending',
      'text-gray-400 cursor-not-allowed': !(item.validity === 'Active' && item.status === 'Pending')
    }"></i>
                            </button>


                        </td>

                    </tr>
                </tbody>
            </table>
          </div>
            <div class="flex justify-end items-center my-5 pt-3 dark:bg-[#1D1D1F] text-right">
                <pagination-controls (pageChange)="onPageChange($event)" [responsive]="true"
                    [previousLabel]="'Previous'" [nextLabel]="'Next'" [screenReaderPaginationLabel]="'Pagination'"
                    [screenReaderPageLabel]="'page'" [screenReaderCurrentLabel]="'Youre on page'">
                </pagination-controls>
            </div>
        </div>


        <div class="flex justify-center my-5 ">
            <button *ngIf="hasData"
                class="flex justify-center bg-[#415CFF] text-white shadow-md font-medium rounded-lg py-2 px-5 text-lg items-center"
                (click)="downloadTemplate1()">
                <i class="fa-solid fa-download px-2" *ngIf="!isDownloading"></i>
                <i class="fa-solid fa-spinner fa-spin px-2" *ngIf="isDownloading"></i>
                {{ isDownloading ? " Downloading..." : " Download" }}
            </button>
        </div>
    </div>